// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5716":"42fca164","6331":"42fca164","6548":"21b72bde","8519":"ed218b90"}[chunkId] + ".chunk.css";
};